/**
 * <s-glow>: a soft, blurred brand glow that eases after the mouse across the whole
 * page (fixed layer, moved with transform only, so it never repaints the page).
 * Fades in on the first move, out when the pointer leaves the window or sits on an image/video.
 * Mouse only; off with reduced motion and on touch.
 */
class SGlow extends HTMLElement {
  #frame = 0;
  #x = 0; #y = 0; #tx = 0; #ty = 0;
  #started = false;
  #onMove = (event) => {
    if (event.pointerType !== 'mouse') return;
    this.#tx = event.clientX;
    this.#ty = event.clientY;
    if (!this.#started) { this.#x = this.#tx; this.#y = this.#ty; this.#started = true; }
    if (!this.hasAttribute('data-on')) this.setAttribute('data-on', '');
    // Fade out over images, videos and the coloured tier cards so screenshots and text stay crisp.
    this.toggleAttribute('data-over-media', Boolean(event.target.closest?.('img, picture, video, iframe, [data-card-frame], [data-hs-intro]')));
    if (!this.#frame) this.#frame = requestAnimationFrame(this.#tick);
  };
  #onOut = (event) => {
    if (!event.relatedTarget) this.removeAttribute('data-on');
  };
  #tick = () => {
    this.#x += (this.#tx - this.#x) * 0.14;
    this.#y += (this.#ty - this.#y) * 0.14;
    this.style.setProperty('--glow-x', `${this.#x.toFixed(1)}px`);
    this.style.setProperty('--glow-y', `${this.#y.toFixed(1)}px`);
    const settled = Math.abs(this.#tx - this.#x) < 0.5 && Math.abs(this.#ty - this.#y) < 0.5;
    this.#frame = settled ? 0 : requestAnimationFrame(this.#tick);
  };

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('pointermove', this.#onMove, { passive: true });
    document.addEventListener('pointerout', this.#onOut);
  }

  disconnectedCallback() {
    document.removeEventListener('pointermove', this.#onMove);
    document.removeEventListener('pointerout', this.#onOut);
    cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-glow')) customElements.define('s-glow', SGlow);
